<template>
  <div class="login-form">
    <h2>ล็อกอิน</h2>
    <form @submit.prevent="login">
      <div class="form-group">
        <label for="username">ชื่อผู้ใช้ / Username:</label>
        <input v-model="username" type="text" required placeholder="ใส่ชื่อผู้ใช้" />
      </div>
      <div class="form-group">
        <label for="password">รหัสผ่าน:</label>
        <input v-model="password" type="password" required placeholder="ใส่รหัสผ่าน" />
      </div>
      <button type="submit">ล็อกอิน</button>
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      errorMessage: null,
    };
  },
  methods: {
    login() {
      fetch("api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: this.username,
          password: this.password,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Invalid username or password");
          }
          return response.json();
        })
        .then(() => {
          this.$emit("login-success"); // Notify parent of login success
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
  },
};
</script>



<style scoped>
/* Add styles here for better UX/UI */
.login-form {
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
}
input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.error {
  color: red;
  margin-top: 10px;
}
</style>
